import React from "react";
import PropTypes from "prop-types";
import classes from "../../FitnessPreview.module.scss"

export default function Tag({ children, backgroundColor = "#3ECAE3", textColor = "#fff" }) {
  return (
    <span
      style={{
        backgroundColor,
        color: textColor,
      }}
      className={classes.customTag}
    >
      {children}
    </span>
  );
}

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
};